import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import lookupActions from '../../../../../actions/lookup.actions';
import helper from '../../../../../utils/helper';
import Loading from '../../../../Helpers/Loading';
import Backend from '../../../../Layouts/Backend';
import AssignAlertsPage from './AssignAlertsPage';

class AssignAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      group: {},
      getGroupError: {},
      departments: [],
      remoteDevices: [],
      loading: false,
      isFetching: false,
      isSubmitting: false,
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.group !== prevState.group) {
      state.group = nextProps.configure.group;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.configure.getGroupError !== prevState.getGroupError) {
      state.getGroupError = nextProps.configure.getGroupError;
    }
    if (nextProps.configure.remoteDevices !== prevState.remoteDevices) {
      state.remoteDevices = nextProps.configure.remoteDevices;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    const { groupId } = this.props.match.params;
    this.setState(
      { loading: true },
      async () =>
        await this.props.configureActions
          .getSpecificGroup(groupId)
          .finally(async () => await this.props.lookupActions.getDepartments())
          .finally(() => this.setState({ loading: false })),
    );
  }
  onChangeDept = (deptId) => {
    this.setState(
      { isFetching: true },
      async () =>
        await this.props.configureActions
          .getRDsByDept(deptId)
          .finally(() => this.setState({ isFetching: false })),
    );
  };
  onAssignAlerts = (rdIds) => {
    const { groupId } = this.props.match.params;
    this.setState(
      { isSubmitting: true },
      async () =>
        await this.props.configureActions
          .assignAlerts(groupId, rdIds)
          .then(() => this.props.history.push('/configure/groups'))
          .catch(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    if (this.state.loading)
      return (
        <Backend>
          <div className="content-inner">
            <Loading />
          </div>
        </Backend>
      );
    return (
      <AssignAlertsPage
        {...this.state}
        onChangeDept={this.onChangeDept}
        onAssignAlerts={this.onAssignAlerts}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignAlerts);
